import * as InventoryModels from '../../models/inventory/inventory';
import * as DepositeModels from '../../models/deposite/deposite';
import * as Models from '../../models/commonModels';

export class GetList {
  static readonly type = '[Inventory] Inventory List';
  constructor(public Search: InventoryModels.InventorySearchModel) { }
}


export class Set {
  static readonly type = '[Inventory] Set';
  constructor(public Inventory: Models.Request<InventoryModels.InventoryModel>) { }
}


export class Get {
  static readonly type = '[Inventory] Get';
  constructor(public Id: Models.RequestModel) { }
}

export class GetCurrent {
  static readonly type = '[Inventory] Get Current';
  constructor() { }
}

export class GetClosest {
  static readonly type = '[Inventory] Get Closest';
  constructor() { }
}

export class SetSearch {
  static readonly type = '[Inventory] Set Search';
  constructor(public Search: InventoryModels.InventorySearchModel) { }
}

export class ResetSearch {
  static readonly type = '[Inventory] Reset Search';
  constructor() { }
}

export class DisposeSearch {
  static readonly type = '[Inventory] Dispose Search';
  constructor() { }
}

export class SetListPage {
  static readonly type = '[Inventory] Set List Page';
  constructor(public Search: InventoryModels.InventorySearchModel) { }
}

export class Delete {
  static readonly type = '[Inventory] Delete';
  constructor(public Inventory: Models.Request<InventoryModels.InventoryModel>) { }
}

export class SetManual {
  static readonly type = '[Inventory] Set Manual';
  constructor(public Inventory: Models.Request<InventoryModels.InventoryModel>,public File: File) { }
}

export class UpladSummary {
  static readonly type = '[Inventory] Uplad Summary';
  constructor(public File: File) { }
}

export class GetManual {
  static readonly type = '[Inventory] Get Manual';
  constructor(public Inventory: Models.Request<InventoryModels.InventoryModel>) { }
}

export class GetDepositeInventories {
  static readonly type = '[Inventory] Get Deposite Inventories';
  constructor(public Deposite: Models.Request<DepositeModels.DepositeModel>) { }
}

export class GetDepositeInventoryChanges {
  static readonly type = '[Inventory] Get Deposite Inventory Changes';
  constructor(public InventoryDeposite: Models.Request<InventoryModels.InventoryDepositeModel>) { }
}

export class SetSummary {
  static readonly type = '[Inventory] Set Summary';
  constructor(public InventoryGarage: Models.Request<InventoryModels.InventoryGarageModel>, public File: File) { }
}

export class ChargeForExtraSeason {
  static readonly type = '[Inventory] Charge For ExtraSeason';
  constructor(public Request: Models.RequestBase) { }
}
